
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { Component, Vue } from 'vue-property-decorator';
import CountDown from '@/components/countdown/rushcountdown.vue';
import Price from '@/components/price/index.vue';
import { flashSaleList } from '@/services/http';
import { Mutation } from 'vuex-class';
import moment from 'moment';
import * as _ from 'lodash';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    BackTop,
    CountDown,
    Price
  },
  filters: {
    formatDate(time: any) {
      return moment(time).format('MM月DD日 HH:mm');
    }
  }
})
export default class extends Vue {
  // 未开始限时抢购
  flashList: any[] = []

  // 进行中限时抢购
  flashIngList: any[] = []

  @Mutation('order/CONFIRMORDER') CONFIRMORDER!: Function

  beforeCreate() {
    (document as any).querySelector('html').setAttribute('style', 'background-color:#f8f8fb;');
  }

  created() {
    this.getFlashSaleList();
  }

  // 获取活动列表
  async getFlashSaleList() {
    const anchor = readCookie('anchor');
    const res: any = await flashSaleList({
      status: 0,
      companyId: 1,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : ''
    });
    const response: any = await flashSaleList({
      status: 1,
      companyId: 1,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : ''
    });
    if (res.data.data && res.data.data.length !== 0) {
      res.data.data.forEach((item: any) => {
        item.detailList.forEach((value: any) => {
          this.$set(value, 'discount_price', _.round(_.subtract(value.price, value.discount_fee), 2));
        });
      });
    }
    if (response.data.data && response.data.data.length !== 0) {
      response.data.data.forEach((item: any) => {
        item.detailList.forEach((value: any) => {
          this.$set(value, 'discount_price', _.round(_.subtract(value.price, value.discount_fee), 2));
        });
      });
    }
    this.flashList = res.data.data;
    this.flashIngList = response.data.data;
  }

  // 到下单页面
  goOrder(list: any, status: number, id:number, buttonnum: number) {
    if (status === 1 && buttonnum !== 0) {
      const confirmlist = [
        {
          panicBuyId: id,
          limit_num: list.limit_num,
          productId: list.product_id,
          mallImage: {
            source_url: list.source_url,
            product_name: list.product_name
          },
          natureList: [],
          nature_value: list.nature_value,
          num: 1,
          id: list.price_id,
          price: list.discount_price,
          totalPrice: list.discount_price
        }
      ];
      this.CONFIRMORDER(confirmlist);
      this.$router.push('/orderconfirm?type=2&from=flashsale');
    }
  }
}
